<template>
  <el-dialog
      title=""
      :visible="visible"
      :before-close="close"
      @opened="onOpen"
      width="560px"
      class="open-session"
      v-if="visible"
      :close-on-click-modal="false"
  >

    <div slot="title">
      <div class="el-dialog__title">Продолжение сессии</div>
      <div class="el-dialog__subtitle">Чтобы продолжить сессию введите пароль, отправленнный на номер: <b>{{ selectUser.user.phone }}</b>
      </div>
    </div>


    <el-form
        :model="sessionForm"
        :rules="rulesCode"
        label-position="top"
        ref="sessionOpenForm"
        @keyup.enter.native="sendCode"
        v-if="enableBtn"
        class="open-session__form"
        v-loading="loading"
    >

      <el-input v-model="sessionForm.code" class="hidden-input"></el-input>

      <el-form-item prop="code" class="session-form">
          <el-input
              ref="sessionContinueCodeForm"
              v-model="sessionForm.code"
              name="sessionCode"
              auto-complete="off"
              placeholder="1234"></el-input>
        </el-form-item>


      <footer-buttons>
        <el-button
            type="primary"
            :loading="loadSendCode"
            @click="sendCode"
            name="sendCode">Далее
        </el-button>
        <el-button
            @click="loadLogic"
            :disabled="currentTime !== 0"
            name="sendCode">Повторить запрос {{ currentTime | seconds }}
        </el-button>
      </footer-buttons>



    </el-form>

  </el-dialog>
</template>

<script>
import {mapGetters} from "vuex"
import FooterButtons from "@/components/dialog/FooterButtons"

export default {
  name: "OpenVisitSessionModal",
  data() {
    return {
      sessionForm: {
        phone: null,
        code: null,
        department_id: null,
      },
      rulesCode: {
        code: [
          {required: true, message: "Введите код", trigger: "blur"},
          {
            pattern: /^\d*$/,
            message: "Введите только цифры",
            trigger: "blur",
          },
        ],
      },
      loadSendCode: !1,
      loading: false,
      enableBtn: !0,
      current: null,
      currentTime: 30,
      timerCode: null,
      load: false,
      cloneSession: null,
      disabled: false,
      form: null,
      error: null,
    };
  },
  watch: {
    currentTime(time) {
      if (time <= 0) {
        this.stopTimer();
      }
    },
  },
  components: {FooterButtons},
  props: {
    selectUser: {
      required: true,
    },
    visible: {
      required: true,
    }
  },
  computed: {
    ...mapGetters("session", {session: "session"}),
  },
  filters: {
    seconds(n) {
      if (n)
        return `0:${n}`;
      else return '';
    },
  },
  methods: {
    onOpen() {
      this.loadLogic();

      this.sessionForm.code = null;

    },
    close() {
      this.$emit('close')
    },
    startTimer() {
      this.currentTime = 30

      this.timerCode = setInterval(() => {
        this.currentTime--;
      }, 1000);
    },
    stopTimer() {
      clearTimeout(this.timerCode);
    },
    loadLogic() {
      this.loading = true;

      this.$api.session
          .visitContinue({visit_id: this.selectUser.id, department_id: this.selectUser.department.id})
          .then((response) => {
            this.cloneSession = response.data

            this.$notify.success({
              title: "Удачно...",
              message: "Код был отправлен",
            });

            this.$nextTick(() => {
              this.$refs.sessionContinueCodeForm.focus();
            })

            this.startTimer()
          })
          .catch((res) => {
            this.$notify.error({
              title: "Ошибка загрузки данных 😕",
              message: res.response.data.message,
            })
            this.close()
          })
          .finally(() => {
            this.loading = !!0;
          })
    },
    sendCode() {
      this.error = null;
      if (this.loading) return

      let data = {code: this.sessionForm.code}

      this.$refs.sessionOpenForm.validate((valid) => {
        if (valid) {

          this.loading = true;
          this.$api.session
              .open(this.cloneSession.id, data)
              .then((response) => {
                this.$emit('openSession', response.data)
              })
              .catch((response) => {
                this.$notify.error({
                  title: "Ошибка загрузки списка сессий 😕",
                  message: response.response.data.message,
                });
              })
              .finally(() => {
                this.loading = false;
              })
        }
      })
    },
  },
};
</script>

<style scoped lang="scss">

.open-session {

  &__btns {
    margin-top: 20px;
  }

  &__item {
    margin: 40px 0;
  }

  .hidden-input {
    display: none;
  }

}


</style>

